import { render, staticRenderFns } from "./DriverPage.vue?vue&type=template&id=29aa0dae"
import script from "./DriverPage.vue?vue&type=script&lang=js"
export * from "./DriverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports